import {entity} from "../../infra/api/rpc/api";
import {CustomerConvertResponse} from "../../infra/api/service/customer_api_convert";
import {calcAgeByBirthDay} from "../../util/commonFuntion";
import {FrontDate} from "./frontDate";
import {SearchHighlight} from "./search_highlight";
import {MultiSkillTag, OccupationSkillTag, SingleSkillTag} from "./skill_tag";

// 語学
export enum Language {
    Language_Unknown = 0,
    // 英語
    Language_English = 1,
    // 韓国語
    Language_Korean = 2,
    // 中国語
    Language_Chinese = 3,
    // スペイン語
    Language_Spanish = 4,
    // ドイツ語
    Language_German = 5,
    // フランス語
    Language_French = 6,
    // その他
    Language_Other = 7,
}

// 語学レベル
export enum SpeakingLevel {
    SpeakingLevel_Unknown = 0,
    // 日常会話レベル
    SpeakingLevel_Basic_Conversation = 1,
    // ビジネスレベル
    SpeakingLevel_Business = 2,
    // ネイティブ
    SpeakingLevel_Native = 3,
}

// (ステータス)
export enum Status {
    Status_Unknown = 0,
    // 審査中
    Status_Inspection = 1,
    // 拒否
    Status_Denied = 2,
    // アクティブ
    Status_Active = 3,
    // Ban
    Status_BAN = 4,
    // 退会
    Status_Delete = 5,
    // 審査通過
    Status_PassedInspection = 6,
    // 審査不通過
    Status_NonPassedInspection = 7,
    // 休会
    Status_Suspend = 8,
    // 非表示
    Status_Hidden = 9,
}

//
export enum WorkingFrequency {
    WorkingFrequency_Unknown = 0,
    // 週1日以下
    WorkingFrequency_Under_1_Day = 1,
    // 週1日〜2日
    WorkingFrequency_1_2_Day = 2,
    // 週2日〜3日
    WorkingFrequency_2_3_Day = 3,
    // 週3日以上
    WorkingFrequency_Over_3_Day = 4,
    // 要相談
    WorkingFrequency_Consultation = 5,
}

// 性別
export enum Gender {
    Gender_Unknown = 0,
    Gender_Male = 1,
    Gender_Female = 2,
}

// Plan
export enum Plan {
    Plan_Unknown = 0,
    // 無料
    Plan_Free = 1,
    // スタンダード
    Plan_Standard = 2,
}

export enum WorkIntention {
    WorkIntention_Unknown = 0,
    // アドバイザリーのみ
    WorkIntention_OnlyAdvice = 1,
    // 手を動かすワークも可能
    WorkIntention_WithWork = 2,
    // 要相談
    WorkIntention_Consultation_Required = 3,
}

// 正社員契約の可能性
export enum FullTimePossibility {
    FullTimePossibility_Unknown = 0,
    // はい
    FullTimePossibility_Yes = 1,
    // いいえ
    FullTimePossibility_No = 2,
}

// コンサルティングファームなどの仲介案件が可能かどうか
export enum BrokerageProjectPossibility {
    BrokerageProjectPossibility_Unknown = 0,
    // はい
    BrokerageProjectPossibility_Yes = 1,
    // いいえ
    BrokerageProjectPossibility_No = 2,
}

// 登録者
export class Customer {
    public static from(from: CustomerConvertResponse): Customer {
        return new Customer(
            from.id,
            from.name,
            from.nameKana,
            from.gsIconURL,
            from.signedIconURL,
            from.birthdate,
            from.gender,
            from.phoneNumber,
            from.email,
            from.pr,
            from.address,
            from.academicBackgrounds,
            from.requirements,
            from.languages,
            from.moreLanguage,
            from.speakingLevel,
            from.status,
            from.resumeURL,
            from.jobHistoryURL,
            from.workingFrequency,
            from.requestedFee,
            from.requestedCondition,
            from.dutySummary,
            from.catchphrase,
            from.createdAt,
            from.highlights,
            from.workIntention,
            from.adminMemo,
            from.interviewMemo,
            from.interviewUpdatedAt,
            from.fullTimePossibility,
            from.brokerageProjectPossibility,
            from.jobCareerCatchphrase,
            from.singleSkillTags,
            from.multiSkillTags,
            from.occupationSkillTags,
            from.portfolio,
            from.displayOccupationSkillCategories,
            from.displayOccupationSkillTags,
            from.type,
            from.birthplace,
            from.facebookURL,
            from.linkedInURL,
            from.xURL,
            from.agenticSummary,
            from.ageGroup,
        );
    }

    constructor(
        // 登録者ID
        public readonly id: string,
        // 名前
        public readonly name: string,
        // ふりがな
        public readonly nameKana: string,
        // (プロフィール画像URL)
        public readonly gsIconURL: string,
        public readonly signedIconURL: string,
        // 生年月日
        public readonly birthdate: FrontDate,
        // 性別
        public readonly gender: Gender,
        // 電話番号
        public readonly phoneNumber: string,
        // メールアドレス // ToDo: readonlyを外す必要があるのか再チェック
        public email: string,
        // 自己PR
        public readonly pr: string,
        // 住所（都道府県）
        public readonly address: string,
        // 学歴 : 配列だが、現状は入力は1つで良い（最終学歴）
        public readonly academicBackgrounds: string[],
        // 資格
        public readonly requirements: string[],
        // 語学
        public readonly languages: Language[],
        public readonly moreLanguage: string,
        // 語学レベル
        public readonly speakingLevel: SpeakingLevel,
        // (ステータス)
        public readonly status: Status,
        // (履歴書） ※初期構想には存在したが、現在マスターデータからは削除されている
        public readonly resumeURL: string,
        // (職務経歴書） ※初期構想には存在したが、現在マスターデータからは削除されている
        public readonly jobHistoryURL: string,
        //
        public readonly workingFrequency: WorkingFrequency,
        //
        public readonly requestedFee: entity.Customer.RequestedFee,
        //
        public readonly requestedCondition: string,
        // 職務要約
        public readonly dutySummary: string,
        //
        public readonly catchphrase: string,
        // (タイムスタンプ)
        public readonly createdAt: FrontDate,
        public readonly highlights: SearchHighlight[],
        public readonly workIntention: WorkIntention,
        public readonly adminMemo: string,
        public readonly interviewMemo: string,
        public readonly interviewUpdatedAt: FrontDate,
        public readonly fullTimePossibility: FullTimePossibility,
        public readonly brokerageProjectPossibility: BrokerageProjectPossibility,
        public readonly jobCareerCatchphrase: string,
        public readonly singleSkillTags: SingleSkillTag[],
        public readonly multiSkillTags: MultiSkillTag[],
        public readonly occupationSkillTags: OccupationSkillTag[],
        public readonly portfolio: string,
        public readonly displayOccupationSkillCategories: string[],
        public readonly displayOccupationSkillTags: string[],
        public readonly type: entity.Customer.Type,
        public readonly birthplace: string,
        public readonly facebookURL: string,
        public readonly linkedInURL: string,
        public readonly xURL: string,
        // AgenticSearchで返却されるLLMによる要約PR（通常の取得時は空文字）
        public readonly agenticSummary: string = "",
        public readonly ageGroup: string = ""
    ) {
    }

    public getBirthdateString(): string {
        // YYYY-MM-DD
        return `${this.birthdate.year}-${this.birthdate.month}-${this.birthdate.day}`;
    }

    public getBirthdateForProfileString(): string {
        const age: number = calcAgeByBirthDay(this.birthdate);

        if (this.birthdate.originValue === "0001-01-01 09:00:00") {
            return ``;
        }

        return `${age}歳`;
    }

    public getAgeString(): string {
        if (this.ageGroup) {
            return this.ageGroup;
        }
        let age: number = calcAgeByBirthDay(this.birthdate);
        age = Math.floor(age / 10) * 10;

        if (
            !this.birthdate.originValue ||
            this.birthdate.originValue === "0001-01-01 09:00:00" ||
            age === 0
        ) {
            return ``;
        }

        return `${age}代`;
    }

    public getIconURL(): string {
        if (this.signedIconURL) {
            return this.signedIconURL;
        } else {
            return this.gsIconURL;
        }
    }

    public getInterviewUpdatedAtString(): string {
        if (!this.interviewUpdatedAt.originValue) {
            return ``;
        }

        // YYYY年MM月DD日
        return `${this.interviewUpdatedAt.year}年${this.interviewUpdatedAt.month}月${this.interviewUpdatedAt.day}日`;
    }

    public getCatchphrase(): string {
        return this.catchphrase ? this.catchphrase : this.name;
    }
}



// WEBPACK FOOTER //
// ./src/domain/model/customer.ts